import { render, staticRenderFns } from "./cloud-recordings-table.component.vue?vue&type=template&id=7896bb1c&"
import script from "./cloud-recordings-table.component.vue?vue&type=script&lang=js&"
export * from "./cloud-recordings-table.component.vue?vue&type=script&lang=js&"
import style0 from "./cloud-recordings-table.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports